import * as Activity from "./components/PlotAPI/Activity";
import * as ApiKey from "./components/PlotAPI/ApiKey";
import * as Areas from "./components/PlotAPI/Area";
import * as CalendarEvent from "./components/PlotAPI/CalendarEvent";
import * as CalendarEventAttachments from "./components/PlotAPI/CalendarEventAttachments";
import * as CommandCenter from "./components/PlotAPI/CommandCenter";
import * as Comments from "./components/PlotAPI/Comments";
import * as Deliveries from "./components/PlotAPI/Delivery";
import * as Dropoff from "./components/PlotAPI/Dropoff";
import * as DropoffGate from "./components/PlotAPI/DropoffGate";
import * as Equipment from "./components/PlotAPI/Equipment";
import * as FireTV from "./components/PlotAPI/FireTV";
import * as Gate from "./components/PlotAPI/Gate";
import * as GateToDropoffRoute from "./components/PlotAPI/GateToDropoffRoute";
import * as Geotiff from "./components/PlotAPI/Geotiff";
import * as HaulRoute from "./components/PlotAPI/HaulRoute";
import * as Integrations from "./components/PlotAPI/Integrations";
import * as Invite from "./components/PlotAPI/Invite";
import * as Login from "./components/PlotAPI/Login";
import * as MagicToken from "./components/PlotAPI/MagicToken";
import * as Map from "./components/PlotAPI/Map";
import * as MappableConversion from "./components/PlotAPI/MappableConversion";
import * as MapObject from "./components/PlotAPI/MapObject";
import * as Material from "./components/PlotAPI/Material";
import * as Messages from "./components/PlotAPI/Messages";
import * as Notifications from "./components/PlotAPI/Notifications";
import * as Order from "./components/PlotAPI/Order";
import * as OrderDelivery from "./components/PlotAPI/OrderDelivery";
import * as Permission from "./components/PlotAPI/Permission";
import * as Procurement from "./components/PlotAPI/Procurement";
import * as Project from "./components/PlotAPI/Project";
import * as ProjectAttachments from "./components/PlotAPI/ProjectAttachments";
import * as RecipientLists from "./components/PlotAPI/RecipientLists";
import * as RepeatingCalendarEventDefinitions from "./components/PlotAPI/RepeatingCalendarEventDefinitions";
import * as ScheduledReports from "./components/PlotAPI/ScheduledReports";
import * as Submittal from "./components/PlotAPI/Submittal";
import * as Team from "./components/PlotAPI/Team";
import * as Trade from "./components/PlotAPI/Trade";
import * as User from "./components/PlotAPI/User";
import * as Vendor from "./components/PlotAPI/Vendor";
import * as WaypointDirection from "./components/PlotAPI/WaypointDirection";
import * as Weather from "./components/PlotAPI/Weather";

const PlotAPI = {
    ...Activity,
    ...ApiKey,
    ...Areas,
    ...CalendarEvent,
    ...CalendarEventAttachments,
    ...CommandCenter,
    ...Comments,
    ...Deliveries,
    ...Dropoff,
    ...DropoffGate,
    ...Equipment,
    ...FireTV,
    ...Gate,
    ...GateToDropoffRoute,
    ...Geotiff,
    ...HaulRoute,
    ...Integrations,
    ...Invite,
    ...Login,
    ...MagicToken,
    ...Map,
    ...MappableConversion,
    ...MapObject,
    ...Material,
    ...Messages,
    ...Notifications,
    ...Order,
    ...OrderDelivery,
    ...Permission,
    ...Procurement,
    ...Project,
    ...ProjectAttachments,
    ...RecipientLists,
    ...RepeatingCalendarEventDefinitions,
    ...ScheduledReports,
    ...Submittal,
    ...Team,
    ...Trade,
    ...User,
    ...Vendor,
    ...WaypointDirection,
    ...Weather,
};

export default PlotAPI;
